import { Expand, LayoutGrid, LayoutList, Loader, Loader2, Minimize } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'

import { ProductCardSkeleton } from '@/modules/product/components/skeletons/product-card.skeleton'
import { ProductCardContainer } from '@/modules/product/containers/product-card.container'
import { Button } from '@/modules/shared/components/ui/button'
import { ScrollArea } from '@/modules/shared/components/ui/scroll-area'
import { cn } from '@/modules/shared/lib/utils'

import { useCatalogComponent } from './use-catalog.hook'
import { ProductSearchInputComponent } from '../shared/product-search/product-search-input.component'

export function CatalogComponent() {
	const {
		handleSubmitSearchProduct,
		isLoadingProducts,
		lastProductOfPaginationCallback,
		isCalculatingOrder,
		products,
		layoutType,
		handleLayout,
	} = useCatalogComponent()
	const [maximize, setMaximize] = useState(false)


	const quantityRef = useRef<HTMLInputElement>(null)
	const inputSearchRef = useRef<HTMLInputElement>(null)

	return (
		<div
			className={cn(
				'space-y-2 grid grid-cols-1 ',
				maximize && 'fixed top-14 z-20 bg-white p-4 left-0 right-0 bottom-0',
			)}
		>
			<div className="flex flex-1 lg:justify-end w-full">
				<div className="flex flex-1 gap-1 mr-2">
					<Button
						variant="secondary"
						onClick={() => setMaximize(!maximize)}
						className={cn('p-2 w-12 h-12 text-gray-600')}
					>
						{maximize ? <Minimize size={20} /> : <Expand size={20} />}
					</Button>

					<Button
						variant="secondary"
						onClick={handleLayout}
						className="p-2 w-12  text-gray-600 mr-1"
					>
						{layoutType === 'grid' ? (
							<LayoutList size={20} />
						) : (
							<LayoutGrid size={20} />
						)}
					</Button>

				</div>

				<div>
					<ProductSearchInputComponent
						isLoadingProducts={isLoadingProducts}
						quantityRef={quantityRef}
						inputRef={inputSearchRef}

						formSearchInputController={{
							onSubmitRequest: handleSubmitSearchProduct,
						}}
					/>
				</div>
			</div>
			{products?.length === 0 && !isLoadingProducts && (
				<div className="flex items-start justify-center min-h-[calc(100vh-20rem)]">
					<p className="text-gray-500 mt-10">Nenhum produto encontrado</p>
				</div>
			)}

			<ScrollArea>
				<div className='flex flex-col mt-2'>

					<div
						className={cn(
							'grid gap-2 grid-cols-1 ',
							layoutType === 'grid' &&
							'min-[590px]:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 3xl:grid-cols-5 ',
							!maximize && 'max-h-[calc(100vh-18rem)]',
						)}
					>


						{products?.map((product, index) => {
							if (products.length === index + 1) {
								return (
									<div
										ref={lastProductOfPaginationCallback}
										key={product.fkProduto}
										className="border-none"
									>
										<ProductCardContainer
											isCalculatingOrder={isCalculatingOrder}
											hasOneProduct={products.length === 1}
											inputSearchRef={inputSearchRef}
											product={product}
											layoutType={layoutType}
											quantityRef={index === 0 ? quantityRef : null}
										/>
									</div>
								)
							}
							return (
								<div key={product.fkProduto} className="">
									<ProductCardContainer
										isCalculatingOrder={isCalculatingOrder}
										hasOneProduct={products.length === 1}
										inputSearchRef={inputSearchRef}
										product={product}
										layoutType={layoutType}
										quantityRef={index === 0 && inputSearchRef?.current?.value ? quantityRef : null}
									/>
								</div>
							)
						})}

						{isLoadingProducts && (
							<div className="flex items-center justify-center col-span-full py-10">
								<div className="text-center ">
									<Loader2 size={36} className="animate-spin mx-auto text-primary mb-2" />
									<p className="text-gray-600">Carregando produtos...</p>
								</div>
							</div>
						)}

					</div>

				</div>

			</ScrollArea>

		</div>
	)
}